import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IModalState, modalTypes } from './types';
import modalActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IModalState = {
  isVisible: false,
  type: '',
  data: {},
  startClosing: false,
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IModalState, payload: UnsafeReturnType<T>): IModalState;
}

const showModal: IActionHandler<typeof modalActions['showModal']> = (state, { payload }) => ({
  data: payload.data,
  type: payload.type,
  isVisible: true,
  startClosing: false,
});

const closeModal: IActionHandler<typeof modalActions['closeModal']> = state => ({
  ...state,
  startClosing: true,
});

const hideModal: IActionHandler<typeof modalActions['hideModal']> = state => ({
  ...INITIAL_STATE,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [modalTypes.SHOW_MODAL]: showModal,
  [modalTypes.HIDE_MODAL]: hideModal,
  [modalTypes.CLOSE_MODAL]: closeModal,
};

const modalReducer = createReducer<IModalState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export default modalReducer;
